import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../../shared/components/Breadcrumbs";
import DefaultButton from "../../../../shared/components/DefaultButton";
import ListView from "../../../../shared/components/listview/ListView";
import Permissions from "../../../../shared/components/Permissions";
import { ruleListDelete, ruleListRequest } from "../redux/Actions";
import {
  ACTIVE,
  CANCEL,
  CREATENEW,
  ESCALATION_RULES,
  INACTIVE,
} from "../../../../shared/constants/Constants";
import Modalpopup from "../../../../shared/components/Modalpopup";
import Loader from "../../../../shared/components/Loader";
import buildEscalationSummaryForRule from "../utils/escalationListSummary";
import { setNextPrevIds } from "../../../next_prev_redux/Actions";

const EscalationRuleList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, ruleList } = useSelector((state) => state.ruleList);

  useEffect(() => {
    if (ruleList?.data?.length) {
      const ids = ruleList.data.map(item => item.id);
      dispatch(setNextPrevIds(ids, "Escalation Rules"));
    }
  }, [ruleList]);

  const escalationRuleColumns = [
    {
      display_name: "id",
      field: "id",
      type: "number",
      hide: true,
      pinned: "left",
    },
    {
      display_name: "Actions",
      field: "actions",
      type: "actions",
      width: 90,
      pinned: "left",
    },
    {
      display_name: "Rule Name",
      field: "rule_name",
      type: "text",
      pinned: "left",
    },
    {
      display_name: "Execution Mode",
      field: "execution_mode",
      type: "dropdown",
      dropdownOptions: ["ticket_creation", "ticket_update", "scheduled"],
    },

     {
      display_name: "Filter",
      field: "additional_conditions_full_summary",
      type: "text",
      width: 1050,
    },
    {
      display_name: "Ticket Action",
      field: "actions_summary",
      type: "text",
      width: 700,
    },
    { display_name: "Status", field: "status_name", type: "text" },
    { display_name: "Category", field: "category_name", type: "text" },
    {
      display_name: "Admin Group",
      field: "admin_group_name",
      type: "text",
    },
     {
      display_name: "Assigned To",
      field: "assigned_to_name",
      type: "text",
    },
    {
      display_name: "Time Trigger",
      field: "time_trigger_enabled",
      type: "icon",
      icon: "checkbox",
    },
  ];

  const [selectedRow, setSelectedRow] = useState({});
  const [clickStatusFunc, setClickStatusFunc] = useState(null);
  const [showStatusModal, setShowStatusModal] = useState(false);

  useEffect(() => {
    dispatch(ruleListRequest());
  }, [dispatch]);

  useEffect(() => {
    setClickStatusFunc(() => (row) => {
      setSelectedRow(row);
      setShowStatusModal(true);
    });
  }, []);

  const clickEdit = (row) => {
    navigate(`/escalationRulesForm/${row.id}`, { state: { id: row.id, isEdit: true } });
  };

  const handleStatus = (row) => {
    if (!row?.id) return;
    dispatch(ruleListDelete({ id: [row.id] }));
    setShowStatusModal(false);
    setSelectedRow({});
  };

  const emp_no = JSON.parse(localStorage.getItem("emp_no"));
  const module_name = "Escalation Rules";
  const permission = Permissions(emp_no, module_name);
  const showLoader = loading;

  // Update rows with summaries using the provided helper
  const processedRows = (ruleList && Array.isArray(ruleList.data))
    ? ruleList.data.map((r) => {
        try {
          const summary = buildEscalationSummaryForRule(r,{ shortMax: 150 });
          return {
            ...r,
            additional_conditions_full_summary: summary.additional_conditions_full_summary,
            actions_summary: summary.actions_summary,
          };
        } catch (err) {
          return r;
        }
      })
    : [];

  return (
    <>
      <Row>
        <Col xl={4} xs={12}>
          <Breadcrumbs children={[{ label: ESCALATION_RULES }]} />
        </Col>
        <Col xl={8} xs={12}>
          {permission.create_permission ? (
            <div className="float-end">
              <DefaultButton
                buttonClass={"default-btn-color"}
                buttonTitle={CREATENEW}
                actionBlock={() => {
                  navigate("/escalationRulesForm/add",{state:{isEdit:false}});
                }}
              />
            </div>
          ) : null}
        </Col>
      </Row>

        {showLoader ? (
          <Loader />
        ) : 
        (
        <Row>
          <Card className="table-card">
            <Card.Body>
              <ListView
                exportTitle={"Escalation Rules"}
                columnNames={escalationRuleColumns}
                rowData={processedRows}
                clickEdit={clickEdit}
                clickStatus={clickStatusFunc}
                tableHeight="70vh"
              />
            </Card.Body>
          </Card>
        </Row>
       ) 
      }
      <Modalpopup
        height="80vh"
        size="lg"
        show={showStatusModal}
        handleClose={() => setShowStatusModal(false)}
        actionTitle="Status Update"
      >
        <p>
          {selectedRow?.status ? (
            <>
              Do you want to make <strong>{selectedRow?.rule_name}</strong>{" "}
              inactive?
            </>
          ) : (
            <>
              Do you want to make <strong>{selectedRow?.rule_name}</strong>{" "}
              active?
            </>
          )}
        </p>

        <div className="col-md-12">
          <DefaultButton
            buttonClass="btn btn-secondary me-2"
            buttonTitle={CANCEL}
            actionBlock={() => setShowStatusModal(false)}
          />
          <DefaultButton
            buttonClass={
              selectedRow?.status ? "btn btn-danger" : "btn btn-success"
            }
            buttonTitle={selectedRow?.status ? INACTIVE : ACTIVE}
            actionBlock={() => handleStatus(selectedRow)}
          />
        </div>
      </Modalpopup>
    </>
  );
};

export default EscalationRuleList;
